import * as React from 'react';
import {GRAY_600, WARNING} from '../constants/Colors';

const WarningIcon = () =>
<svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <path d="m0 0h16v16h-16z"/>
        <g className="svg-invalid">
            <path
                d="m15.34 12.843-6.279-11.06a1.222 1.222 0 0 0 -2.124 0l-6.277 11.061a1.223 1.223 0 0 0 1.062 1.824h12.554a1.223 1.223 0 0 0 1.062-1.824z"/>
            <path d="m8 5v4m0 2.333-.003 1" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
    </g>
</svg>;


export default WarningIcon;
